export const currency = "$";
